import { acceptContractAndSchedule } from "../../constants/commonConstants";

export const getValidationErrorMessage = (touched, errors) => {
  const touchedErrors = Object.entries(touched)
    .sort((a, b) => {
      const [keyA] = a;
      if (keyA === acceptContractAndSchedule) {
        return -1;
      }
      return 1;
    })
    .reduce((accumulator, [touchedKey, touchedValue]) => {
      const error = errors[touchedKey];
      if (touchedValue === true && error) {
        accumulator.push(error);
      }

      return accumulator;
    }, []);

  return touchedErrors[0];
};